import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { Utilities, TimeUnit } from 'src/utilities';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class FirstVisit implements ICondition {
  private matchType?: MatchType | null;
  private conditionValue?: number | null;
  private timeUnit?: TimeUnit | null;

  constructor({ matchType, count, unitOfTime }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = count;
    this.timeUnit = unitOfTime;
  }

  public evaluate({
    targetingData,
    sdkInfo,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const visitsData = targetingData?.[KameleoonData.VisitsData];

    if (
      sdkInfo.isServer
        ? !visitsData?.visits.length
        : !visitsData?.visits || visitsData.visits.length < 2
    ) {
      return Ok(false);
    }

    const firstVisit = visitsData!.visits[0];

    return Ok(
      this.checkCondition(
        typeof firstVisit === 'number' ? firstVisit : firstVisit.timeStarted,
      ),
    );
  }

  private checkCondition(firstVisitTimestamp: number): boolean {
    if (
      !this.matchType ||
      typeof this.conditionValue !== 'number' ||
      !this.timeUnit
    ) {
      return false;
    }

    const elapsedTimeMilliseconds = Date.now() - firstVisitTimestamp;
    const elapsedTimeUnit = Utilities.convertTimeUnit(
      elapsedTimeMilliseconds,
      this.timeUnit,
    );

    switch (this.matchType) {
      case MatchType.GREATER:
        return elapsedTimeUnit > this.conditionValue;
      case MatchType.LOWER:
        return elapsedTimeUnit < this.conditionValue;
      default:
        KameleoonLogger.error`Unexpected comparing operation for FirstVisit condition: ${this.matchType}`;
        return false;
    }
  }
}
